import { ReactNode } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

interface Props {
  label: ReactNode;
  required?: RegisterOptions['required'];
}

const OptionalLabel = ({ label, required }: Props) => {
  return (
    <>
      {label}
      {!required && (
        <>
          {' '}
          <FormattedMessage id="form.label.optional" />
        </>
      )}
    </>
  );
};

export default OptionalLabel;
